
import { cancelReservationClient, getReservationClientPriceInfo } from '@/api/reservationClient';
import { Form } from 'element-ui';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getBankInfoListAll } from '@/api/bankInfo';

@Component({
  name: 'RefundMnagement',
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private uid!: string;

  mounted() {
    this.getReservationClientPriceInfo();
  }

  get price() {
    return this.reservationDetail.price;
  }

  private reservationDetail: any = {
    originPrice: 0,
    price: 0,
    additionalPrice: 0,
    hourPrice: 0,
    serviceName: '',
    reservationCode: '',
    name: '',
  };

  private loading = true;

  private form = {
    cancelReason: '',
    fee: 0,
    feePercentage: 0,
    refundType: 0,
  }

  private rules = {
    cancelReason: [
      { required: true, message: '환불사유를 입력해주세요.', trigger: 'blur' },
    ],
    reasonInput: [
      { required: true, message: '환불 상세사유를 입력해주세요.', trigger: 'blur' },
    ],
    refundType: [
      { required: true, message: '환불방식을 선택해주세요.', trigger: 'blur' },
    ],
    refundPrice: [
      { required: true, message: '차감금액을 입력해주세요.', trigger: 'blur' },
    ],
    feePercentage: [
      { required: true, message: '차감율(%)를 입력해주세요.', trigger: 'blur' },
    ],
    refundAcctNum: [
      { required: true, message: '환불될 계좌번호를 입력해주세요.', trigger: 'blur' },
      { pattern: /^[0-9]+$/, message: '올바른 계좌번호를 입력해주세요.', trigger: 'blur' },
    ],
    refundBankCode: [
      { required: true, message: '환불될 계좌 은행을 선택해주세요.', trigger: ['blur', 'change'] },
    ],
    refundAcctName: [
      { required: true, message: '환불될 계좌 예금주명을 입력해주세요.', trigger: 'blur' },
    ],
  }

  private bankList = [];

  private closeForm() {
    this.$emit('close');
  }

  private getReservationClientPriceInfo() {
    this.loading = true;
    getReservationClientPriceInfo(this.uid).then((res) => {
      this.reservationDetail = res.data;
      this.loading = false;
      if (res.data.paymentType && res.data.paymentType.toUpperCase() === 'VBANK') {
        getBankInfoListAll().then((res2) => {
          this.bankList = res2.data;
        });
      }
    }).catch(() => {
      this.$message.warning('예약정보를 불러오는데 실패했습니다.');
      this.closeForm();
    });
  }

  private submitForm() {
    (this.$refs.form as Form).validate((valid:boolean) => {
      if (valid) {
        this.$confirm('확인을 누르시면 환불이 진행됩니다. 계속하시겠습니까?', '환불 진행', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          type: 'warning',
        }).then(() => {
          this.loading = true;
          cancelReservationClient(this.uid, this.form).then(() => {
            this.$message({
              type: 'success',
              message: '환불 및 예약취소를 완료됐습니다.',
            });
            this.$emit('submit', this.form);
          }).catch(() => {
            this.loading = false;
          });
        });
      }
    });
  }

  private getPercentFee() {
    return (this.price * (this.form.feePercentage / 100)).toFixed();
  }
}
